import { useMemo, type ReactNode } from 'react';
import { ApiProvider } from '@mono-farmart-web/utilities/contexts/api-context';
import { useConfigContext } from './config-context';
import { useSessionContext } from './session-context';
import { useUserContext } from './user-context';
import { getFarmartAIBaseUrl } from '../utils/api-base-url';

export const APIContainer = ({ children }: { children: ReactNode }) => {
	const { customHeaders } = useConfigContext();
	const { sessionId } = useSessionContext();
	const { userId } = useUserContext();
	const config = useMemo(
		() => ({
			baseURL: getFarmartAIBaseUrl(),
			headers: {
				authorization: `Bearer ${import.meta.env.VITE_FARMART_AI_AUTH_TOKEN}`,
				'x-user-id': userId,
				'x-session-id': sessionId,
				...customHeaders,
			},
		}),
		[customHeaders, sessionId, userId],
	);
	return <ApiProvider config={config}>{children}</ApiProvider>;
};
